<!-- Add the popup component -->
<app-popup [page]="'user_profile_page'"></app-popup>
<div
  class="bg-white rounded-10 p-3 mb-4"
  *ngIf="_user.userstate | async as userdetail"
>
  <div class="row users-profile">
    <div class="col-12 col-lg-4">
      <div class="row justify-content-center text-lg-center">
        <div class="col-auto col-lg-12">
          <img
            [src]="userdetail?.user?.user_avatar | baseUrl"
            alt="user pick"
            class="img-fluid user-profile-pic mb-2"
          />
        </div>
        <div class="col col-lg-12 mb-2 align-self-center">
          <h5 class="fw-bolder mb-0">
            {{ userdetail?.user?.name }}
            <img
              *ngIf="userdetail?.user?.membership"
              src="../../../../assets/icons/vip_icon.svg"
              alt="VIP"
              class="img-fluid"
            />
          </h5>
          <div class="user-profile-location small">
            <img
              src="../../../../assets/icons/location.svg"
              class="img-fluid me-1"
            />
            {{ userdetail?.user?.city }}
          </div>
        </div>
        <div
          class="col-auto col-lg-12 align-self-center"
          *ngIf="_user.authUser | async as user"
        >
          <ng-container *ngIf="user.id != userdetail?.id">
            <a
              href="javascript:void(0)"
              *ngIf="!userdetail?.user?.is_followed"
              (click)="followUnfollow(user, 'follow')"
              class="follow-style fw-bolder"
              >Follow</a
            >
            <a
              href="javascript:void(0)"
              *ngIf="userdetail?.user?.is_followed"
              (click)="followUnfollow(user, 'unfollow')"
              class="unfollow-style fw-bolder"
              >Unfollow</a
            >
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <div class="row px-lg-3">
        <div class="col-md-6 py-2 border-bottom border-light">
          Rank
          <span class="float-end">{{ userdetail?.rank || "NR" }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          Winnings
          <span class="float-end">{{
            userdetail?.total_winnings || 0 | CustomCurrency
          }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          Days betting
          <span class="float-end">{{
            userdetail?.days_betting || 0 | number
          }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          Top Sports
          <span class="float-end">{{ userdetail?.top_sport || "N/A" }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          # of bets
          <span class="float-end">{{
            userdetail?.total_bets || 0 | number
          }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          Followers
          <span class="float-end">{{
            userdetail?.followers || 0 | number
          }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          Yesterday's Winnings
          <span class="float-end">{{
            userdetail?.last1daysWinnings || 0 | CustomCurrency
          }}</span>
        </div>
        <div class="col-md-6 py-2 border-bottom border-light">
          W-L-D (win%)
          <span class="float-end"
            >{{ userdetail?.count_wins || 0 | number }}-{{
              userdetail?.count_loss || 0 | number
            }}-{{ userdetail?.count_draw || 0 | number }} ({{
              userdetail?.win_percent
            }}%)</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <app-profile></app-profile>
  </div>
</div>
